var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CBadge',{attrs:{"bg-class":"tw-bg-promote-turbo","text-class":"tw-text-white","icon":_vm.ciStar}},[_vm._v("\n  "+_vm._s(_vm.$t('promoted::condition'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }